<template>
	<component 
		:is="component" 
		:data="data" 
		v-if="component" 
		v-bind:columnClasses="columnClasses" 
		:ready="isReady" 
		v-on:heightChange="heightChange"/>
</template>

<script>
import FlexibleContentBlock from '../../FlexibleContentBlockBase'
export default {
	extends: FlexibleContentBlock,
	name: 'dynamic-media-block',
	props: ['data', 'columnClasses', 'isReady'],
	computed: {
		loader() {
			if (!this.type) {
				return null
			}
			return () => import(`./content/${this.type}`)
		},
	},
	methods: {
		heightChange() {
			this.$emit('heightChange')
		}
	}
}
</script>